import type { CompanyEmailReviewDetail } from '@/services/companyAiService';

type ProjectSuggestion = CompanyEmailReviewDetail['projectSuggestions'][number];

export function getVisibleProjectSuggestions(detail: Pick<CompanyEmailReviewDetail, 'projectSuggestions'> | null): ProjectSuggestion[] {
  const suggestions = detail?.projectSuggestions || [];
  const acceptedSuggestions = suggestions.filter((suggestion) => suggestion.reviewStatus === 'accepted');

  if (acceptedSuggestions.length > 0) {
    return acceptedSuggestions;
  }

  return suggestions.filter((suggestion) => suggestion.reviewStatus !== 'rejected');
}
